import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Modal from '@buyside/components/presentation/Modal/modal';
import PostTweetForm from '@buyside/components/presentation/Twitter/PostTweet/postTweetForm';

import styles from '@buyside/components/presentation/Twitter/twitterStyles.scss';

const PostTweetModal: React.FC<{
  buttonTitle?: string;
  colorClass?: string;
  forHighlight?: boolean;
  initialTweetMsg?: string;
  tweetPrompt?: string;
}> = ({
  buttonTitle,
  colorClass,
  forHighlight,
  initialTweetMsg,
  tweetPrompt = 'Share on Twitter'
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const modalButtonProps = useMemo(
    () =>
      forHighlight
        ? {
            className: classNames(styles.highlightButtonOpenModal, colorClass),
            type: BUTTON_TYPES.PRIMARY
          }
        : { text: tweetPrompt, type: BUTTON_TYPES.LINK },
    [forHighlight, colorClass, tweetPrompt]
  );

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        {...modalButtonProps}
        faIcon={faTwitter}
        title={buttonTitle}
        onClick={() => setIsModalOpen(true)}
      />
    ),
    [modalButtonProps, buttonTitle]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title={tweetPrompt}
    >
      <PostTweetForm initialTweetMsg={initialTweetMsg} />
    </Modal>
  );
};

export default PostTweetModal;
